import { render, staticRenderFns } from "./CommentsListItem.vue?vue&type=template&id=0f1ed891&scoped=true"
import script from "./CommentsListItem.vue?vue&type=script&lang=js"
export * from "./CommentsListItem.vue?vue&type=script&lang=js"
import style0 from "./CommentsListItem.vue?vue&type=style&index=0&id=0f1ed891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1ed891",
  null
  
)

export default component.exports